import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import rawMetaTags from '../../../helpers/metatags.json';

interface ICanonical {
    replace: () => string;
}
interface IMetatags {
    title?: string;
    description?: string;
    canonical?: string | ICanonical;
    style?: string
}

const SEO = ({ page }: { page: string }) => {
    const { i18n } = useTranslation();

    const metaTags: Record<string, Record<string, object>> = rawMetaTags;
    const meta: IMetatags = metaTags[i18n.language][page];

    if (!meta) return null;

    return (
        <Helmet>
            {/* TITLE */}
            {meta.title ? <title>{meta.title}</title> : null}

            {/* DESCRIPTION */}
            {meta.description && <meta name="description" content={meta.description} />}

            {/* CANONICAL */}
            {meta.canonical && typeof meta.canonical === 'string' ? (
                <>
                    <link rel="canonical" href={meta.canonical} />
                    <link rel="alternate" hrefLang="de" href={meta.canonical.replace('/en', '/de')} />
                    <link rel="alternate" hrefLang="en" href={meta.canonical} />
                </>
            ) : null}

            {/* STYLE */}
            {meta.style && <style>{meta.style}</style>}
        </Helmet>
    );
};

export default SEO;